import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, isConnectable, id, selected }) => (
  <AerosNode id={id} type="attendant" selected={selected} isConnectable={isConnectable}>
    {data.user?.name}
  </AerosNode>
));
